<template>
    <div class="gdpr-right">
        <dt class="gdpr-right__title">
            {{ title }}
        </dt>
        <dd class="gdpr-right__description">
            {{ description }}.
        </dd>
    </div>
</template>

<script>

export default {

    props: {
        description: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },

}

</script>

<style lang="scss">

.gdpr-right {
    display: block;

    @include element('title') {
        font-weight: bold;
        display: inline;

        &:after {
            content: ' - ';
        }
    }

    @include element('description') {
        display: inline;
        margin: 0;
    }
}

</style>
